import { Component, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { DeliveryZonesService } from '../../_services/deliveryzones.service';
import { PreparationCenter, ZipCode } from '../../_models';

@Component({
  selector: 'app-delivery-zones',
  templateUrl: './delivery-zones.component.html',
  styleUrls: ['./delivery-zones.component.css']
})
export class DeliveryZonesComponent implements OnInit {

  public preparationCenters: PreparationCenter[];
  public zipCodes: ZipCode[];

  constructor(
    private header: HeaderService,
    public translate: TranslateService,
    private delivery: DeliveryZonesService
  ) {
    this.header.setHeader(false,false,true,true);
  }

  ngOnInit() {
    this.delivery.getPreparationCenters().subscribe(result => {
      this.preparationCenters = result;
      
    });


    this.delivery.getZipCodes().subscribe(result => {
      this.zipCodes = result;
    });
   
  }

  formatZipCodes(zipCodes: string): string {
    const zipArray = zipCodes.split(',');
    if (zipArray.length > 1) {
      const conjunction = this.translate.currentLang === 'ca' ? ' i ' : ' y ';
      return zipArray.slice(0, -1).join(', ') + conjunction + zipArray.slice(-1);
    }
    return zipArray[0];
  }

}
